import { useState, useCallback } from "react";
import { GoogleMap, useJsApiLoader, OverlayView } from "@react-google-maps/api";
import { Link } from "react-router-dom";
import { GOOGLE_MAPS_KEY } from "../lib/api";
import { formatINR } from "../lib/format";

const containerStyle = { width: "100%", height: "100%" };

const mapOptions = {
  disableDefaultUI: false,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  styles: [
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
  ],
};

export function MapView({ properties = [] }) {
  const { isLoaded } = useJsApiLoader({ googleMapsApiKey: GOOGLE_MAPS_KEY || "" });
  const [active, setActive] = useState(null);

  const center = properties.length
    ? { lat: properties[0].lat, lng: properties[0].lng }
    : { lat: 22.9734, lng: 78.6569 };

  const onLoad = useCallback((map) => {
    if (properties.length > 1) {
      const bounds = new window.google.maps.LatLngBounds();
      properties.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
      map.fitBounds(bounds, 60);
    }
  }, [properties]);

  if (!GOOGLE_MAPS_KEY) {
    return <div className="h-full flex items-center justify-center text-pbs-grey text-sm">Map unavailable (missing API key)</div>;
  }
  if (!isLoaded) {
    return <div className="h-full flex items-center justify-center text-pbs-grey text-sm">Loading map…</div>;
  }

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={properties.length > 1 ? 10 : 12} options={mapOptions} onLoad={onLoad}>
      {properties.map((p) => (
        <OverlayView key={p.slug} position={{ lat: p.lat, lng: p.lng }} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
          <div className="relative -translate-x-1/2 -translate-y-full" data-testid={`map-marker-${p.slug}`}>
            <button
              onClick={() => setActive(active?.slug === p.slug ? null : p)}
              className={`px-2.5 py-1 rounded-full text-xs font-bold shadow-lg border-2 border-white whitespace-nowrap transition-transform hover:scale-110 ${active?.slug === p.slug ? "bg-pbs-orange text-white" : "bg-pbs-purple text-white"}`}
            >
              {formatINR(p.price)}
            </button>
            <span className="absolute left-1/2 -translate-x-1/2 -bottom-1.5 w-2.5 h-2.5 rotate-45 bg-pbs-purple border-r-2 border-b-2 border-white" />
            {active?.slug === p.slug && (
              <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-56 bg-white rounded-xl shadow-2xl border border-pbs-line overflow-hidden z-50">
                <Link to={`/property/${p.slug}`}>
                  <img src={p.image} alt={p.name} className="w-full h-24 object-cover" />
                  <div className="p-2.5 text-left">
                    <p className="font-bold text-sm text-pbs-dark line-clamp-1">{p.name}</p>
                    <p className="text-xs text-pbs-grey line-clamp-1">{p.locality}, {p.city}</p>
                    <p className="text-sm font-extrabold text-pbs-purple mt-0.5">{formatINR(p.price)}</p>
                  </div>
                </Link>
              </div>
            )}
          </div>
        </OverlayView>
      ))}
    </GoogleMap>
  );
}

export default MapView;
